import ChangePasswordForm from '@/redux/auth/ChangePassword/ChangePasswordForm';

function ChangePassword() {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <ChangePasswordForm />
    </div>
  );
}

export default ChangePassword;
